import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InMemoryCacheService } from 'src/app/common/cache/in-memory-cache.service';
import { UtilsService } from 'src/app/common/services/utils.service';
import { Event } from 'src/app/common/events/event-base';
import { SeoApiService } from 'src/app/pages/seo/seo-api.service';
import { SiteSearchService } from 'src/app/pages/seo/site-search/site-search.service';
import { BaseSearchResultsComponent } from '../base-search-results/base-search-results.component';
import { Table, TableModule } from 'primeng/table';
import { BacklinksRequest } from 'src/app/pages/seo/models/site-search-request';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BacklinksResultsComponent } from '../backlinks-results/backlinks-results.component';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TruncatePipe } from 'src/app/common/pipes/truncate.pipe';

@Component({
  selector: 'gig-anchor-results',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, TooltipModule, DynamicDialogModule, TranslateModule, TruncatePipe, BacklinksResultsComponent],
  templateUrl: './anchor-results.component.html',
  styleUrls: ['./anchor-results.component.scss'],
  providers: [DialogService]
})
export class AnchorResultsComponent extends BaseSearchResultsComponent implements OnInit {

  public selectedBacklink: any;
  public nestedRowToShow: string = '' || 'referringDomains' || 'referringPages';
  public openBacklinksDropDown: boolean = false;
  public openReferringDomainsDropDown: boolean = false;
  public selectedReferringDomainRow: any;
  private dialogRef: DynamicDialogRef | undefined;

  @Output() pageChanged: EventEmitter<AnchorsResultsEvent> = new EventEmitter<AnchorsResultsEvent>();
  @Input() public target: string;
  @ViewChild('dt') public dt: Table;

  constructor(public utils: UtilsService, public cache: InMemoryCacheService, public seoApiService: SeoApiService, private dialogService: DialogService,
    public siteSearchService: SiteSearchService, private ref: ChangeDetectorRef) { 
    super(utils);
  }

  ngOnInit(): void {
    this.nestedRowToShow = '';
    this.cols = [
      {field: 'anchor', header: 'Anchor Text'},
      {field: 'referringDomains', header: 'Referring Domains'},
      {field: 'referringPages', header: 'Referring Pages'},
      {field: 'backlinks', header: 'Backlinks'},
      {field: 'rank', header: 'Rank'},
      {field: 'brokenBacklinks', header: 'Broken Backlinks'},
      {field: 'brokenPages', header: 'Broken Pages'},
      {field: 'firstSeen', header: 'First Seen'}
    ]
   
  }

  public onPageChanged(e: any): void {
    this.utils.logger.info('AnchorResultsComponent.onPageChanged() ');
    this.pageChanged.emit(new AnchorsResultsEvent('AnchorResultsComponent.PAGE_CHANGED', e));
  }

  public async getReferringDomains(row: any) {

    const filter: string = `["anchor", "=", "${row.anchor}"]`;
    const payload: BacklinksRequest = {
      target: this.target,
      filtersString: filter,
      mode: 'one_per_domain',
      limit: this.cache?.seoLimits?.anchorReferringDomainsBacklinks
    }

    this.cache.loading = true;
    const { data, error } = await this.seoApiService.getBacklinks(payload);
    this.cache.loading = false;

    this.dialogRef = this.dialogService.open( BacklinksResultsComponent, {
      header: 'Referring Domains',
      draggable: true,
      width: '50vw',
      data: data.items,
      resizable: true
    })
  }

  public async getBacklinks(row: any) {

    const filter: string = `["anchor", "=", "${row.anchor}"]`;
    const payload: BacklinksRequest = {
      target: this.target,
      filtersString: filter,
      mode: 'as_is',
      limit: this.cache?.seoLimits?.anchorReferringPagesBacklinks
    }

    this.cache.loading = true;
    const { data, error } = await this.seoApiService.getBacklinks(payload);
    this.cache.loading = false;
    
    this.dialogRef = this.dialogService.open(BacklinksResultsComponent, {
      header: 'Backlinks',
      draggable: true,
      width: '50vw',
      data: data.items,
      resizable: true
    })
  }
}

export class AnchorsResultsEvent extends Event {
  constructor(type: string, payload: any) {
    super(type, payload);
  }
}